import { CmsPage } from '@/service';

/**
 * @class @name Content
 * @description Exposes menu store module
 */
export default class Page {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name loadPageItem
			 * @param {function} commit
			 * @param {string} id
			 */
			async loadPageItem(context, id) {
				return CmsPage.get(id);
			}
		};
	}
}
